import moment, { Moment } from "moment";

export const disableFutureDates = (current: moment.Moment): boolean => {
  return current && current > moment().endOf("day");
};

export const disableFutureTime = (selectedDate: Moment) =>
  (currentTime: Moment) => {
    const now = moment();
    if (!currentTime || !selectedDate || !currentTime.isSame(selectedDate, 'day')) {
      return {};
    }

    const currentHour = now.hour();
    const currentMinute = now.minute();

    return {
      disabledHours: () => {
        const hours = [];
        for (let h = currentHour + 1; h < 24; h++) {
          hours.push(h);
        }
        return hours;
      },
      disabledMinutes: (selectedHour: number) => {
        const minutes = [];
        if (selectedHour === currentHour) {
          for (let m = currentMinute + 1; m < 60; m++) {
            minutes.push(m);
          }
        }
        return minutes;
      },
    };
  };
  